import SDIcon from '../SDIcon'
import type { SDIconProps } from '../SDIcon'

const IconCall = ({ size = 16, color = 'currentColor', ...props }: SDIconProps) => (
  <SDIcon viewBox='0 0 24 24' size={size} color={color} aria-hidden='true' {...props}>
    <path
      d='M6.6 3.5h2.6l1.4 4-2 1.4a12 12 0 0 0 6.5 6.5l1.4-2 4 1.4v2.6a2 2 0 0 1-2.2 2A16.5 16.5 0 0 1 4.6 5.7a2 2 0 0 1 2-2.2z'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.9'
      strokeLinejoin='round'
    />
  </SDIcon>
)

export default IconCall
